/*USAGE EXAMPLE
<BuyPlanComponent productId={1206} productCode="BIL_ZPL_NLI_MIN_INV_100"/>
*/
import { useState } from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BuyPlanButton } from './BuyPlanButton/BuyPlanButton';
import { CalculateCartToken } from 'engine/baseApiClient';

export const BuyPlanComponent = ({ productId, productCode }) => {
  const [cartToken, setCartToken] = useState('');

  useEffect(() => {
    const calculateCartToken = async () => {
      let token = (await CalculateCartToken({ productId: productId })).cartToken;
      setCartToken(token);
    };
    calculateCartToken().catch((error) => console.log(error));
  }, []);

  return (
    <>
      {productId !== null && (
        <form
          action="https://panel.sellintegro.pl/pl/koszyk"
          target="_blank"
          style={{ display: 'flex', width: '100%' }}
        >
          <input id="add" name="add" type="hidden" value={1} />
          <input id="cart_token" name="cart_token" type="hidden" value={cartToken} />
          <input id="id_product" name="id_product" type="hidden" value={productId} />
          <input id="demander" name="demander" type="hidden" value="sellintegro.pl" />
          <input id="create_customization" name="create_customization" type="hidden" value={productCode} />
          <BuyPlanButton type="submit">Uruchom teraz</BuyPlanButton>
        </form>
      )}
    </>
  );
};

BuyPlanComponent.propTypes = {
  productId: PropTypes.number,
  productCode: PropTypes.text,
};
